import { CITATION_INDEX_SAMPLE } from '../classnames/scientific-citations';
import { HIDDEN } from '../classnames/design-system';
import CitationLinksContainer from './citation-links-container';

export default class CitationIndexComponent {
  constructor({ index, id, prependComma }) {
    this.index = index;
    this.id = id;
    this.prependComma = prependComma;
  }

  citationIndexSample = document.querySelector(`.${CITATION_INDEX_SAMPLE}`);

  onClick = () => {
    (new CitationLinksContainer()).expand();
  };

  render = () => {
    const newCitationIndex = this.citationIndexSample.cloneNode(true);
    const newCitationIndexLink = newCitationIndex.querySelector('a');
    if (this.prependComma) {
      newCitationIndex.prepend(',');
    }
    newCitationIndex.addEventListener('click', this.onClick);
    newCitationIndexLink.href = `#${this.id}`;
    newCitationIndexLink.innerHTML = this.index;
    newCitationIndex.classList.remove(HIDDEN);
    return newCitationIndex;
  };
}
